import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

import { AnalyticsService } from '../../../core/analytics';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { IconConfirmationDialogComponent } from '../../icon-confirmation-dialog/icon-confirmation-dialog.component';
import { SharedConstants } from '../../shared.constants';
import { RefreshService } from '../../../core/refresh.service';

@Component({
  selector: 'campaign-messaging',
  templateUrl: './messaging.component.html',
  styleUrls: ['./messaging.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})

export class MessagingComponent implements OnInit {
    @Input() emailCopy: string = ''
    @Input() appCopy: string = '';
    @Input() index: number = 0;
    @Input() isMobile: boolean;
    @Input() title: string;
    @Output() updateCopy = new EventEmitter< { body?: string; appMessage?: string }>();
    @Output() goBack: EventEmitter<void>= new EventEmitter<void>();

    public emailMessageChanges: boolean = false;
    public appMessageChanges: boolean = false;
    public unsavedChangesTitle: string = SharedConstants.unsavedChangesTitle;
    public unsavedChangesText: string = SharedConstants.unsavedChangesText;
    public unsavedChangesIcon: string = SharedConstants.unsavedChangesIcon;
    public unsavedChangesConfirm: string = 'Apply'
    public unsavedChangesCancel: string = SharedConstants.unsavedChangesCancelButton;
    public originalEmailCopy: string;
    public originalAppCopy: string;
    public emailCharacterLimit = 10000;

    constructor(private readonly router: Router,
                private readonly analytics: AnalyticsService,
                private readonly refreshService: RefreshService,
                private readonly dialog: MatDialog) { }

    public ngOnInit() {
      if (this.refreshService.wasRefreshed) {
        this.router.navigate(['/discover']);
      } else {
        window.scroll(0, 0);
        this.originalEmailCopy = this.emailCopy
        this.originalAppCopy = this.appCopy
      }
    }

    public emailMessageUpdate(copy) {
      this.emailCopy = copy;
      this.emailMessageChanges = true;
      this.updateCopy.emit({ body: copy })
    }

    public appMessageUpdate(evt) {
      this.appCopy = evt.target.value;
      this.appMessageChanges = true;
      this.updateCopy.emit({ appMessage: evt.target.value })
    }

    public apply() {
      if (this.emailMessageChanges) {
        this.analytics.sendEvent(
          'Discover Reward Email Copy Changed',
          { updatedRewardEmailCopy: this.emailCopy }
        );

      }
      if (this.appMessageChanges) {
        this.analytics.sendEvent(
          'Discover Default Message For App Changed',
          { updatedAppCopy: this.appCopy }
        );
      }
      this.goBack.emit()
    }

    public tabChanged(index: number) {
      this.index = index;
    }

    public isInvalid() {
      if (this.index === 0 ) {
        return !this.emailCopy.trim() || !this.emailMessageChanges || this.emailCopy.length >= this.emailCharacterLimit;
      } else if ( this.index == 1 ) {
        return !this.appCopy.trim() || !this.appMessageChanges;
      }
      return false;
    }

    resetAndGoBack() {
      this.updateCopy.emit({
        body: this.originalEmailCopy,
        appMessage: this.originalAppCopy
      })
      this.goBack.emit()
    }

    // If there are unsaved copy changes, open the confirmation dialog
    // This will accept a function as an input that will be called based on confirmation dialog status
    public checkForUnsavedChanges() : void {
      if (this.emailMessageChanges || this.appMessageChanges) {
        let config: MatDialogConfig = {
          data: {
            title: this.unsavedChangesTitle,
            displayText: this.unsavedChangesText,
            iconUrl: this.unsavedChangesIcon,
            cancelText: this.unsavedChangesCancel,
            confirmText: this.unsavedChangesConfirm
          },
          autoFocus: false,
          panelClass: 'dialog-responsive'
        }

        this.dialog.open(IconConfirmationDialogComponent, config).afterClosed().subscribe((shouldCancel) => {
          if (shouldCancel === false) {
            this.resetAndGoBack()
          } else {
            this.apply();
          }
        });
      } else {
        this.resetAndGoBack()
      }
    }
}
